let state = {
  source: null,
  playing: false,
  title: "",
  artist: "",
  album: "",
  artwork: "",
  duration: 0,
  position: 0,
  quality: "",
  codec: "",
  bitDepth: null,
  sampleRate: null,
  bitrate: null,
  queue: [],
  queueIndex: 0,
  updatedAt: Date.now(),
};

const listeners = new Set();

export function getPlayerState() {
  return state;
}

export function setPlayerState(next) {
  state = {
    ...state,
    ...next,
    updatedAt: Date.now(),
  };

  try {
    localStorage.setItem(
      "pj_player_state",
      JSON.stringify(state)
    );
  } catch {}

  listeners.forEach((fn) => fn(state));
}

export function subscribePlayerState(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

window.addEventListener("storage", (e) => {
  if (e.key !== "pj_player_state") return;

  try {
    const next = JSON.parse(e.newValue);

    if (!next) return;

    state = next;

    listeners.forEach((fn) => fn(state));
  } catch {}
});
